import { useContext, useEffect, useState } from "react";

import Checkbox from "antd/lib/checkbox";
import type { CheckboxProps } from "antd";
import DatePicker from "antd/lib/date-picker";
import Directories from "../../../../../../directories";
import Drawer from "../../../../../../ui/drawer";
import Form from "antd/lib/form";
import { FormContext } from "../../../../../../../contexts/form/index.context";
import Input from "antd/lib/input";
import InputNumber from "antd/lib/input-number";
import { MergedColumnType } from "../../../../../../ui/table/utils/types";
import { ModalContext } from "../../../../../../../contexts/modal/index.context";
import Select from "antd/lib/select";
import { SessionContext } from "../../../../../../../contexts/session/index.context";
import Space from "antd/lib/space";
import Table from "antd/lib/table";
import { TableContext } from "../../../../../../../contexts/table/index.context";
import Tabs from "antd/lib/tabs";
import type { TabsProps } from "antd/es/tabs";
import { TranslationContext } from "../../../../../../../contexts/translation/index.context";
import Typography from "antd/lib/typography";
import { request } from "../../../../../../../services";
import { useLocation } from "react-router-dom";
import { DrawerProvider } from "../../../../../../../contexts/drawer/index.context";

import en from "antd/es/date-picker/locale/en_US";
import ua from "antd/es/date-picker/locale/uk_UA";

//Components

//UI

const { Title } = Typography;
const { TextArea } = Input;

interface DocumentCharacteristicsProps {
  pathname: string;
  onChange: CheckboxProps["onChange"];
}

export function ActionsWithDocuments({ pathname }: { pathname: string }) {
  const location = useLocation();
  const { intl } = useContext(TranslationContext);
  const { form } = useContext(FormContext);
  const { activeModal } = useContext(ModalContext);
  const { sessionData } = useContext(SessionContext);
  const { rowData } = useContext(TableContext);
  const [documentTypesData, setDocumentTypesData] = useState<
    MergedColumnType[]
  >([]);
  const [newDocumentData, setNewDocumentData] = useState<MergedColumnType[]>(
    []
  );

  const documentTypesOptions = documentTypesData.map((item) => ({
    value: item.id,
    label: item.name,
  }));

  const newDocumentOptions = newDocumentData.map((item) => ({
    value: item.id,
    label: item.name,
  }));

  const fetchDocumentTypesData = async () => {
    const content = (
      await request(`${location.pathname}/getdataselect`, {
        method: "get",
        cancelTokenKey: "getdataselect",
      })
    )?.content;
    setDocumentTypesData(content || []);
  };

  const fetchNewDocumentData = async () => {
    const content = (
      await request(`${location.pathname}/getdataselect`, {
        method: "get",
        cancelTokenKey: "getdataselect",
      })
    )?.content;
    setNewDocumentData(content || []);
  };

  const items: TabsProps["items"] = [
    {
      key: "1",
      label: intl("basic-parameters"),
      children: (
        <>
          <Form.Item name="executionDate" valuePropName="checked">
            <Checkbox>{intl("fill-execution-date")}</Checkbox>
          </Form.Item>
          <Form.Item name="controllingPerson" valuePropName="checked">
            <Checkbox>
              {intl("fill-controlling-person-when-passing-the-route")}
            </Checkbox>
          </Form.Item>
          <Space size="large" align="start">
            <Form.Item name="deadline" valuePropName="checked">
              <Checkbox>{intl("track-the-deadline")}</Checkbox>
            </Form.Item>
            <Form.Item
              // label={intl("set-date-execution-from-the-document-project-date")}
              name="dateExecution"
            >
              <Input style={{ width: "55px" }} />
            </Form.Item>
          </Space>
          <Form.Item name="mailingList" valuePropName="checked">
            <Checkbox>
              {intl("enter-mailing-list-after-document-registration")}
            </Checkbox>
          </Form.Item>
          <Space size={"large"}>
            <Form.Item name="entryFile" valuePropName="checked">
              <Checkbox>{intl("mandatory-entry-file")}</Checkbox>
            </Form.Item>
            <Form.Item name="editFile" valuePropName="checked">
              <Checkbox>
                {intl("allowed-edit-the-file-if-no-execution-date")}
              </Checkbox>
            </Form.Item>
          </Space>
          <Form.Item name="afterSendSEV" valuePropName="checked">
            <Checkbox>{intl("after-sending-sev")}</Checkbox>
          </Form.Item>
          <Form.Item
            label={intl("content-action-stage")}
            name="contentActionStage"
          >
            <TextArea rows={4} />
          </Form.Item>
        </>
      ),
    },
    {
      key: "2",
      label: intl("changing-the-route"),
      children: (
        <Form.Item name="isResult" valuePropName="checked">
          <Checkbox>{intl("mandatory-entry-of-the-result")}</Checkbox>
        </Form.Item>
      ),
    },
  ];

  function setFormFields() {
    if (/* edit &&  */ rowData) {
      const fieldsValue: any = {};
      if (rowData["/directories/structural-units"]) {
        fieldsValue.structuralUnit =
          rowData["/directories/structural-units"].id;
      }
      form.setFieldsValue(fieldsValue);
    }
  }

  return (
    <>
      <Space size="large">
        <Form.Item label={intl("code")} name="code" rules={[{ max: 10 }]}>
          <Input />
        </Form.Item>
        <Form.Item name="controlAction" valuePropName="checked">
          <Checkbox>{intl("control-action")}</Checkbox>
        </Form.Item>
      </Space>
      <Form.Item label={intl("action-stage")} name="actionStage">
        <Input />
      </Form.Item>
      <Form.Item label={intl("notes")} name="notes">
        <Input />
      </Form.Item>
      <Space size="large" style={{width: "100%"}}>
        <Form.Item label={intl("use-for-document-types")} name="documentTypes" style={{width: "100%"}}>
          <Select
            style={{width: "315px"}}
            onChange={(_, value) => {
              form.setFieldsValue({ documentTypes: value });
            }}
            onDropdownVisibleChange={fetchDocumentTypesData}
            options={documentTypesOptions}
            allowClear
          />
        </Form.Item>
        <Form.Item
          label={intl("add-when-creating-a-new-document")}
          name="newDocument"
        >
          <Select
            style={{width: "315px"}}
            onChange={(_, value) => {
              form.setFieldsValue({ newDocument: value });
            }}
            onDropdownVisibleChange={fetchNewDocumentData}
            options={newDocumentOptions}
            allowClear
          />
        </Form.Item>
      </Space>
      <Tabs className="TABS=========STYLE============" defaultActiveKey="1" items={items} /* onChange={onChange} */ />
    </>
  );
}

export function NomenclatureOfCasesCurrent({ pathname }: { pathname: string }) {
  const { intl, language } = useContext(TranslationContext);

  const { form } = useContext(FormContext);
  const { activeModal } = useContext(ModalContext);
  const { sessionData } = useContext(SessionContext);
  const { rowData } = useContext(TableContext);
  const edit = activeModal === "edit";
  const dateFormatList = ["DD.MM.YYYY", "DD-MM-YYYY"];
  const [structuralUnitId, setStructuralUnitId] = useState<number | undefined>(edit ? sessionData.sta_otdel_id : undefined);

  function setFormFields() {
    if (/* edit &&  */ rowData) {
      const fieldsValue: any = {};
      if (rowData["/directories/structural-units"]) {
        fieldsValue.structuralUnit =
          rowData["/directories/structural-units"].id;
          setStructuralUnitId(rowData["/directories/structural-units"].id);
      }
      form.setFieldsValue(fieldsValue);
    }
  }

  return (
    <>
      <DrawerProvider>
      <Form.Item label={intl("structural-unit")} name="structuralUnit">
        <Drawer
          url="/directories/structural-units"
          name={edit ? sessionData.NAME_OTDEL : undefined}
          name2={rowData["/directories/structural-units"]?.data.Name}
          setFormFields={setFormFields}
          fieldName={"structuralUnit"}
        >
          <Directories url="/directories/structural-units" selectedRowId={structuralUnitId}/>
        </Drawer>
      </Form.Item>
      <Space size={"large"}>
        <Form.Item
          label={intl("nomenclature-no")}
          name="numNomenclature"
          rules={[
            { max: 20 },
            {
              required: true,
              message: intl("nomenclature-no-required"),
            },
          ]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          label={intl("year")}
          name="year"
          rules={[
            { type: "number", min: 1900, max: new Date().getFullYear() },
            {
              required: true,
              message: intl("year-required"),
            },
          ]}
        >
          <InputNumber />
        </Form.Item>
      </Space>
      <Title level={4}>{intl("approved")}</Title>
      <Space size={"large"}>
        <Form.Item label={intl("from")} name="from">
          <DatePicker
            format={dateFormatList}
            placeholder={intl("choose-date-placeholder")}
            locale={language ? ua : en}
          />
        </Form.Item>
        <Form.Item name="valid" valuePropName="checked">
          <Checkbox>{intl("valid")}</Checkbox>
        </Form.Item>
      </Space>
      <Form.Item label={intl("document")} name="document">
        <Input />
      </Form.Item>
      <Form.Item label={intl("notes")} name="approvalNotes">
        <TextArea rows={4} />
      </Form.Item>
      <Form.Item label={intl("general-notes")} name="notes">
        <TextArea rows={4} />
      </Form.Item>
      <Form.Item name="addNum" valuePropName="checked">
        <Checkbox>{intl("add-num-nomenclature")}</Checkbox>
      </Form.Item>
      <Form.Item name="addC" valuePropName="checked">
        <Checkbox>{intl("add-letter-c")}</Checkbox>
      </Form.Item>
    </DrawerProvider>
    </>
  );
}

export function NomenclatureOfCases({ pathname }: { pathname: string }) {
  const { intl } = useContext(TranslationContext);
  const { form } = useContext(FormContext);
  const { activeModal } = useContext(ModalContext);
  const { sessionData } = useContext(SessionContext);
  const { rowData } = useContext(TableContext);
  const edit = activeModal === "edit";
  const [nomenclatureOfCasesCurrentId, setNomenclatureOfCasesCurrentId] = useState<number | undefined>(edit ? sessionData.eta_OfficialDocYear_id : undefined);

  function setFormFields() {
    if (/* edit &&  */ rowData) {
      const fieldsValue: any = {};
      if (rowData["/directories/nomenclature-of-cases-current"]) {
        fieldsValue.nomenclatureOfCasesCurrent =
          rowData["/directories/nomenclature-of-cases-current"].id;
          setNomenclatureOfCasesCurrentId(rowData["/directories/nomenclature-of-cases-current"].id);
      }
      form.setFieldsValue(fieldsValue);
    }
  }

  return (
    <>
      <DrawerProvider>
      <Form.Item
        label={intl("nomenclature-of-cases-current")}
        name="nomenclatureOfCasesCurrent"
      >
        <Drawer
          url="/directories/nomenclature-of-cases-current"
          name={edit ? sessionData.NAME_OTDEL : undefined}
          name2={
            rowData["/directories/nomenclature-of-cases-current"]?.data
              .NAME_OTDEL
          }
          setFormFields={setFormFields}
          fieldName={"nomenclatureOfCasesCurrent"}
        >
          <Directories url="/directories/nomenclature-of-cases-current" selectedRowId={nomenclatureOfCasesCurrentId}/>
        </Drawer>
      </Form.Item>
      <Form.Item
        label={intl("index")}
        name="index"
        rules={[
          { max: 20 },
          {
            required: true,
            message: intl("index-required"),
          },
        ]}
      >
        <Input />
      </Form.Item>
      <Form.Item
        label={intl("heading")}
        name="heading"
        rules={[
          {
            required: true,
            message: intl("heading-required"),
          },
        ]}
      >
        <Input />
      </Form.Item>
      <Form.Item label={intl("shelf-life")} name="shelfLife">
        <Input />
      </Form.Item>
      <Form.Item label={intl("notes")} name="notes">
        <Input />
      </Form.Item>
      </DrawerProvider>
      </>
  );
}

export function ResolutionTemplates({ pathname }: { pathname: string }) {
  const { intl } = useContext(TranslationContext);
  const { form } = useContext(FormContext);
  const { activeModal } = useContext(ModalContext);
  const { sessionData } = useContext(SessionContext);
  const { rowData, contextTableData, setContextTableData } =
    useContext(TableContext);
  const edit = activeModal === "edit";
  // const sessionDataId: number | null  = sessionData?.id === typeof "number" ? sessionData?.id : null;
  const [authorId, setAuthorId] = useState<number | undefined>(edit ? sessionData.sta_clerks_id : undefined);
const [sessionDataId, setSessionDataId] = useState<number | undefined>(
 edit ? (typeof sessionData?.id === "number" ? sessionData.id : undefined) : "add"
);


  // useEffect(() => {
  // //  console.log("ID SESSIONDATA ", sessionData.id);
  // //  console.log("SESSIONDATA ", sessionData);
  // //  console.log("CONTEXT TABLE DATA ============= ", contextTableData);

  // }, [sessionData, contextTableData, setContextTableData]);

  useEffect(() => {
    setContextTableData([]); // Для перетирання і заборони запиту до сервера бо там якесь дивне id при запиті resolution-templates
  }, [activeModal]);

  useEffect(() => {
    const selectedIds = [
      ...(contextTableData?.flatMap(
        (item) => item.ExecutorFIO?.split(", ") || []
      ) || []),
    ];
    form?.setFieldsValue({
      executors: selectedIds,
      resolutionData: contextTableData,
    });

    // console.log("EXECUTORS useEffect ", form.getFieldsValue());
  }, [contextTableData]);

  function setFormFields() {
    if (/* edit &&  */ rowData) {
      const fieldsValue: any = {};
      if (rowData["/directories/employees"]) {
        fieldsValue.author = rowData["/directories/employees"].id;
        setAuthorId(rowData["/directories/employees"].id);
      }

      // if (rowData["/directories/resolution-templates/executors"]) {
      //   fieldsValue.executors = rowData["/directories/resolution-templates/executors"].id;
      // }

    if (rowData["/directories/resolution-templates"]) {
      const id = rowData["/directories/resolution-templates"].id;
      setSessionDataId(typeof id === "number" ? id : undefined);
    }
      form.setFieldsValue(fieldsValue);
    }
  }

  return (
    <>
      <DrawerProvider>
      <Form.Item label={intl("text-resolution")} name="text">
        <Input />
      </Form.Item>
      <Form.Item label={intl("author")} name="author">
        <Drawer
          url="/directories/employees"
          name={edit ? sessionData.fio : undefined}
          name2={rowData["/directories/employees"]?.data.fio}
          setFormFields={setFormFields}
          fieldName={"structuralUnit"}
        >
          <Directories url="/directories/employees" selectedRowId={authorId}/>
        </Drawer>
      </Form.Item>
      <Form.Item name="notDisplayListPerformers" valuePropName="checked">
        <Checkbox>{intl("not-display-the-list-of-performers")}</Checkbox>
      </Form.Item>
      <Form.Item /* label={intl("author")} */ name="executors">
        <Directories
          url="/directories/resolution-templates/executors"
          id={sessionDataId}
          activeModal={activeModal}
          form={form}
          tableData={contextTableData}
        />
        {/* <Table dataSource={dataSource} columns={columns} rowSelection={rowSelection} /> */}
      </Form.Item>
      <Form.Item name="resolutionData" hidden />
      </DrawerProvider>
      </>
  );
}

export function DocumentCharacteristics({
  pathname,
  onChange,
}: DocumentCharacteristicsProps) {
  const { activeModal } = useContext(ModalContext);
  const edit = activeModal === "edit";
  const location = useLocation();

  const { intl } = useContext(TranslationContext);
  return (
    <>
      <Form.Item
        label={intl("code")}
        name="code"
        rules={[{ max: 10, message: intl("the-number-of-allowed") }]}
      >
        <Input />
      </Form.Item>
      <Form.Item
        label={intl("name")}
        name="name"
        rules={[
          {
            required: true,
            message: intl("name-required"),
          },
        ]}
      >
        <Input />
      </Form.Item>
      <Form.Item label={intl("notes")} name="notes">
        <Input />
      </Form.Item>
      {/* Компонент чекбокс Видалено в модалці Види документів */}
      {pathname === "/directories/types-of-documents" &&
      location.pathname === pathname ? (
        edit && (
          <Space>
            <Form.Item name="deleted" valuePropName="checked">
              <Checkbox value="deleted" onChange={onChange}>
                {intl("deleted")}
              </Checkbox>
            </Form.Item>
          </Space>
        )
      ) : (
        location.pathname === "/directories/types-of-communication" || location.pathname === "/directories/document-categories" || "/directories/indexes-of-documents" || "/directories/results-of-actions" ? 
          null
        :
        <Space>
          <Form.Item name="incoming" valuePropName="checked">
            <Checkbox value="1" onChange={onChange}>
              {intl("incoming")}
            </Checkbox>
          </Form.Item>
          <Form.Item name="outcoming" valuePropName="checked">
            <Checkbox value="2" onChange={onChange}>
              {intl("outcoming")}
            </Checkbox>
          </Form.Item>
          <Form.Item name="internal" valuePropName="checked">
            <Checkbox value="3" onChange={onChange}>
              {intl("internal")}
            </Checkbox>
          </Form.Item>
        </Space>
      )}
      {pathname === "/directories/results-of-actions" && (
        <Form.Item name="fillContent" valuePropName="checked">
          <Checkbox>{intl("fill-in-the-content-of-the-response")}</Checkbox>
        </Form.Item>
      )}
    </>
  );
}

export function TypesOfReceiptsColumns({ pathname }: { pathname: string }) {
  // const location = useLocation();
  const { intl } = useContext(TranslationContext);
  const { form } = useContext(FormContext);
  // const { activeModal } = useContext(ModalContext);
  // const { sessionData } = useContext(SessionContext);
  // const { rowData } = useContext(TableContext);
  // const edit = activeModal === "edit";
  // const [staOtdelData, setStaOtdelData] = useState<MergedColumnType[]>([]);
  // const staOtdel = staOtdelData.map((item) => ({
  //   value: item.id,
  //   label: item.name,
  // }));

  // const fetchStructuralUnitData = async () => {
  //   const content = (
  //     await request(`${pathname}/getdataselect`, {
  //       method: "get",
  //       cancelTokenKey: "getdataselect",
  //     })
  //   )?.content;
  //   setStaOtdelData(content || []);
  // };

  return (
    <>
      {/* <Title level={5}>{intl("journal")}</Title> */}
      <Form.Item label={intl("code")} name="code">
        <Input />
      </Form.Item>
      <Form.Item label={intl("name")} name="name">
        <Input />
      </Form.Item>
      {/* <Form.Item name="staReferenceId">
        <Input />
      </Form.Item> */}
      <Form.Item label={intl("notes")} name="notes">
        <Input />
      </Form.Item>
    </>
  );
}
